<div class="premium-modal-wrapper">

  <!-- ═══ HEADER ═══ -->
  <ion-header class="ion-no-border premium-header">
    <div class="header-curve"></div>
    <div class="custom-toolbar">
      <div class="toolbar-content">
        <div class="icon-btn" (click)="dismiss()">
          <ion-icon name="chevron-back-outline"></ion-icon>
        </div>
        <div class="title-group">
          <div class="title-main">Informe Fotográfico</div>
          <div class="title-sub">{{ trabajo?.lugar }}</div>
        </div>
        <div class="icon-btn" style="visibility: hidden;">
          <ion-icon name="close"></ion-icon>
        </div>
      </div>
    </div>
  </ion-header>

  <!-- ═══ SEGMENT ═══ -->
  <ion-toolbar class="segment-toolbar ion-no-border">
    <ion-segment (ionChange)="segmentChanged($event)" [value]="segment" mode="ios" class="premium-segment">
      <ion-segment-button value="ANTES">
        <ion-label>
          <ion-icon name="time-outline"></ion-icon>
          Antes
          <span class="sel-badge" *ngIf="selectedAntes.length > 0">{{ selectedAntes.length }}</span>
        </ion-label>
      </ion-segment-button>
      <ion-segment-button value="DESPUES">
        <ion-label>
          <ion-icon name="checkmark-done-outline"></ion-icon>
          Después
          <span class="sel-badge despues" *ngIf="selectedDespues.length > 0">{{ selectedDespues.length }}</span>
        </ion-label>
      </ion-segment-button>
    </ion-segment>
  </ion-toolbar>

  <!-- ═══ CONTENT ═══ -->
  <ion-content class="content-bg" [fullscreen]="false">

    <!-- Instrucción -->
    <div class="instructions-bar">
      <ion-icon name="information-circle-outline"></ion-icon>
      <span>Toca cada imagen para seleccionarla o deseleccionarla como foto de <strong>{{ segment === 'ANTES' ? 'Antes' : 'Después' }}</strong>.</span>
    </div>

    <!-- Formulario Dinámico de Metadatos -->
    <div class="report-form-card">
      <div class="form-header">
        <ion-icon name="document-text-outline"></ion-icon>
        <span>Metadatos del Informe (Acta de Entrega)</span>
      </div>

      <div class="form-grid">
        <!-- Ubicación / Sucursal — fila completa -->
        <div class="input-group full-width">
          <label>Ubicación / Sucursal</label>
          <div class="premium-input-wrapper">
            <ion-icon name="location-outline" class="input-icon"></ion-icon>
            <input type="text" [(ngModel)]="ubicacion" placeholder="Ej. Principal">
          </div>
        </div>

        <!-- N° de Cotización -->
        <div class="input-group">
          <label>N° de Cotización <span class="required">*</span></label>
          <div class="premium-input-wrapper">
            <ion-icon name="receipt-outline" class="input-icon"></ion-icon>
            <input type="text" [(ngModel)]="cotizacionNum" placeholder="Obligatorio">
          </div>
        </div>

        <!-- N° de OT Asignada -->
        <div class="input-group">
          <label>N° de OT Asignada</label>
          <div class="premium-input-wrapper">
            <ion-icon name="construct-outline" class="input-icon"></ion-icon>
            <input type="text" [(ngModel)]="otAsignada" placeholder="Opcional">
          </div>
        </div>

        <!-- Fecha — fila completa -->
        <div class="input-group full-width">
          <label>Fecha</label>
          <div class="premium-input-wrapper date-input">
            <ion-icon name="calendar-outline" class="input-icon"></ion-icon>
            <input type="date" [(ngModel)]="fechaInforme">
          </div>
        </div>
      </div>
    </div>

    <!-- Loading -->
    <div class="loading-container" *ngIf="isLoading">
      <ion-spinner name="crescent" color="primary"></ion-spinner>
      <p>Cargando galería...</p>
    </div>

    <!-- Empty state -->
    <div class="empty-state" *ngIf="!isLoading && filteredImages.length === 0">
      <ion-icon name="images-outline"></ion-icon>
      <p>No hay imágenes en la categoría <strong>{{ segment }}</strong>.</p>
      <span>Agrega imágenes en la galería del trabajo clasificadas como "{{ segment === 'ANTES' ? 'Antes' : 'Después' }}".</span>
    </div>

    <!-- Mosaico de selección -->
    <div class="gallery-mosaic" *ngIf="!isLoading && filteredImages.length > 0">
      <div
        *ngFor="let img of filteredImages"
        class="image-wrapper"
        [class.selected]="isSelected(img)"
        (click)="toggleSelect(img)">

        <div class="img-container-mosaic">
          <ng-container *ngIf="img.imagen_path | imageAuth:getImagePath(img.source, img.imagen_path) | async as imageSrc; else imgLoading">
            <img [src]="imageSrc" alt="Foto" class="mosaic-img" />

            <!-- Overlay de selección -->
            <div class="selection-overlay" [class.active]="isSelected(img)">
              <div class="check-circle" [class.checked]="isSelected(img)">
                <ion-icon name="checkmark" *ngIf="isSelected(img)"></ion-icon>
              </div>
            </div>

            <!-- Caption -->
            <div class="image-info-overlay" *ngIf="img.texto">
              <p class="caption-tag">{{ img.texto }}</p>
            </div>
          </ng-container>

          <ng-template #imgLoading>
            <div class="loading-placeholder">
              <ion-spinner name="crescent" color="primary"></ion-spinner>
            </div>
          </ng-template>
        </div>
      </div>
    </div>

    <div class="bottom-spacer"></div>
  </ion-content>

  <!-- ═══ FOOTER DE ACCIÓN ═══ -->
  <ion-footer class="ion-no-border form-footer-actions" *ngIf="!isLoading">
    <div style="width: 100%; display: flex; flex-direction: column; gap: 12px; align-items: center; justify-content: center;">
      <div class="footer-summary" style="margin-bottom: 0;">
        <div class="summary-chip antes">
          <ion-icon name="time-outline"></ion-icon>
          <span>{{ selectedAntes.length }} Antes</span>
        </div>
        <div class="summary-chip despues">
          <ion-icon name="checkmark-done-outline"></ion-icon>
          <span>{{ selectedDespues.length }} Después</span>
        </div>
      </div>
      <ion-button
        class="save-btn"
        style="width: 100%; max-width: 320px;"
        [disabled]="totalSelected === 0 || isGenerating"
        (click)="generarInforme()">
        <ion-spinner name="crescent" *ngIf="isGenerating" slot="start"></ion-spinner>
        <ion-icon name="document-text-outline" slot="start" *ngIf="!isGenerating"></ion-icon>
        <span *ngIf="!isGenerating">Generar Informe Fotográfico</span>
        <span *ngIf="isGenerating">Generando...</span>
      </ion-button>
    </div>
  </ion-footer>

</div>
